import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Calculator, FileText } from "lucide-react";

export const ProcessSteps = () => {
  const navigate = useNavigate();
  
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <Card className="p-6 bg-secondary/10 border-secondary/20 hover:bg-secondary/20 transition-all cursor-pointer"
            onClick={() => navigate('/dashboard/calculator')}>
        <div className="flex items-start space-x-4">
          <div className="p-3 bg-primary/20 rounded-lg">
            <Calculator className="w-6 h-6 text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-2">Step 1: Calculate Your Savings</h3>
            <p className="text-sm text-muted-foreground">
              Use our calculator to see how much you could save. 
              Standard reduction: 60% of obligations
            </p>
            <Button 
              variant="link" 
              className="mt-4 text-foreground font-semibold px-4 py-2 shadow-lg hover:shadow-xl transition-all duration-200 hover:text-foreground/90 hover:translate-y-[-2px]"
              onClick={(e) => {
                e.stopPropagation();
                navigate('/dashboard/calculator');
              }}
            >
              Calculate Now →
            </Button>
          </div>
        </div>
      </Card>

      <Card className="p-6 bg-secondary/10 border-secondary/20 hover:bg-secondary/20 transition-all cursor-pointer"
            onClick={() => navigate('/dashboard/documents')}>
        <div className="flex items-start space-x-4">
          <div className="p-3 bg-primary/20 rounded-lg">
            <FileText className="w-6 h-6 text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-2">Step 2: Submit Documents</h3>
            <p className="text-sm text-muted-foreground">
              Upload required documents securely. Quick submission unlocks additional savings.
            </p>
            <Button 
              variant="link" 
              className="mt-4 text-foreground font-semibold px-4 py-2 shadow-lg hover:shadow-xl transition-all duration-200 hover:text-foreground/90 hover:translate-y-[-2px]"
              onClick={(e) => {
                e.stopPropagation();
                navigate('/dashboard/documents');
              }}
            >
              Upload Documents →
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};